import './bootstrap';

// Externals
import '@wwdev/bootstrap/index.js';
import '@wwdev/functions/index.js';

import './wwdev/forms/index';

import '@fancyapps/fancybox';

import './wwdev/lazysizes/index.js';
import './wwdev/webshop/index.js';

import '@wwdev/myaccount/index.js';
import '@wwdev/register';
import '@wwdev/search';
import '@wwdev/functions/setEqualHeightsPerRow';


import './base/cookiebar';
import './base/popup';
import './base/popupVer';

import './externals/hamburgers.js';
import './externals/flickity/index.js';
import './externals/raty';
import './externals/animation';
import './externals/youtube';
import './externals/whatsapp';
import './externals/tooltips';

// Vendor
import '@medicalllifesupport/opleiding'

import './vendor/shared/mobile-header';
import './vendor/shared/header.js'

import './vendor/product/filterMenu';

import './vendor/search/Search'

import './vendor/register/ehboFields'

// Components
import './components/number-input';

// Sections
import './sections/brands';
import './sections/news';
import './sections/popup';
